export class CommunityCard {
  constructor (
    public location: number,
    public money: number,
    public description: string
  ) { }
}



// WEBPACK FOOTER //
// /Users/philipeskins/Desktop/Epicodus/monopoly/src/app/community-cards.model.ts